import { render, staticRenderFns } from "./merge-settings-modal.vue?vue&type=template&id=b349c7ea&"
import script from "./merge-settings-modal.vue?vue&type=script&lang=js&"
export * from "./merge-settings-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports